function _objectDestructuringEmpty(obj) {if (obj == null) throw new TypeError("Cannot destructure " + obj);}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Translate } from "../../I18N";
import { CurrentLocationLink } from "../../Layout";
import { searchParamsFromSearchParams } from "../../utils/routeHelpers";

const disableButton = (page, pageToDisable) => ({
  className: page === pageToDisable ? 'btn disabled' : 'btn',
  rel: page === pageToDisable ? 'nofollow' : undefined
});

const Paginator = ({ page, totalPages, onPageChange }) => {
  const prevPage = page - 1 || 1;
  const nextPage = page + 1 > totalPages ? totalPages : page + 1;
  return /*#__PURE__*/(
    _jsx("div", { className: "paginator" }, void 0, /*#__PURE__*/
    React.createElement(CurrentLocationLink, _extends({
      queryParams: { page: prevPage },
      onClick: (e) => {
        e.preventDefault();
        onPageChange(prevPage);
      } },
    disableButton(page, 1)), /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Previous")
    ), /*#__PURE__*/
    _jsx("span", {}, void 0, ` ${page} / ${totalPages} `), /*#__PURE__*/
    React.createElement(CurrentLocationLink, _extends({
      queryParams: { page: nextPage },
      onClick: (e) => {
        e.preventDefault();
        onPageChange(nextPage);
      } },
    disableButton(page, totalPages)), /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Next")
    )
    ));

};

Paginator.defaultProps = {
  page: 1,
  totalPages: 1,
  onPageChange: () => {}
};







// eslint-disable-next-line react/no-multi-comp
const PaginatorWithPage = (props) => {
  const [searchParams] = useSearchParams();
  const query = searchParamsFromSearchParams(searchParams);
  const restProps = _extends({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/React.createElement(Paginator, _extends({}, restProps, { page: Number(query.page || 1) }));
};

export { PaginatorWithPage };